/* Accordéons (FAQ et corps de texte) */
import $ from "jquery";

$('.accordion__title').click(function() {
    var $this = $(this);
    var $parent = $this.parent('.accordion');
    var $openedBoxes = $('.accordion.active');
  
    if($parent.length) {
        if($openedBoxes.length) {
            $openedBoxes.each(function(index, box) {
                if(box === $parent[0]) {
                    $openedBoxes.splice(index, 1);
                }
            });
            
            if($openedBoxes.length) {
                $openedBoxes.removeClass('active');
            }
        }
  
        $parent.toggleClass('active');
    }
  
    var bodyRect = document.body.getBoundingClientRect();
    var $thisRect = $this[0].getBoundingClientRect();
  
    var headerHeight = document.querySelector('header').offsetHeight;
    var scrollToOffest = 30;
  
    window.scrollTo(0, ($thisRect.top - bodyRect.top) - (headerHeight + scrollToOffest));
  });
  